const Joi = require('joi');

export const LwfSchema = Joi.object({
    state_id: Joi.number().integer().positive().required()
        .messages({
            'number.base': 'state must be a number',
            'number.integer': 'state must be an integer',
            'number.positive': 'state must be a positive number',
            'any.required': '"state_id" is a required field'
        }),
    employee_contribution: Joi.number().integer().min(0).required()
        .messages({
            'number.base': 'employee contribution must be a number',
            'number.integer': 'employee contribution must be an integer',
            'number.min': 'employee contribution must be at least 0',
            'any.required': 'employee contribution is a required field'
        }),
    employer_contribution: Joi.number().integer().min(0).required()
        .messages({
            'number.base': 'employer contribution must be a number',
            'number.integer': 'employer contribution must be an integer',
            'number.min': 'employer contribution must be at least 0',
            'any.required': 'employer contribution is a required field'
        }),
    deduction_type: Joi.string().valid('Monthly', 'Quarterly', 'Half Yearly', 'Yearly').required()
        .messages({
            'string.base': '"deduction_type" must be a string',
            'any.only': '"deduction_type" must be one of [Monthly, Quarterly, Half Yearly, Yearly]',
            'any.required': '"deduction_type" is a required field'
        }),
});

// s